export default __webpack_public_path__ + "static/media/status_dark.79a28f56.svg";